import { HTTP } from '../../utils'

export const getCourses = (streamUuid, currentYear, currentSemester) => {
  let url = ''
  if (streamUuid && currentYear && currentSemester) {
    url = '/entity/courseBySemester/' + streamUuid + '/?currentYear=' + currentYear + '&currentSemester=' + currentSemester
  } else {
    return
  }
  return HTTP().get(url)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
}

export const exportEventsToICal = (streamUuid, currentYear, currentSemester) => {
  let url = ''
  if (streamUuid && currentYear && currentSemester) {
    url = '/entity/exportAsICalFile/' + streamUuid + '/?currentYear=' + currentYear + '&currentSemester=' + currentSemester
  } else {
    return
  }
  return HTTP().get(url)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
}

export const getStreamsForUser = (userId) => {
  let url = ''
  if (userId) {
    url = '/entity/myStream?ownerId=' + userId + '&page=0&count=100'
  } else {
    return
  }
  return HTTP().get(url)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
}

export const deleteFromStream = (streamUuid, currentYear, currentSemester, objectData, entityType, sendChannelMessage) => {
  let url = ''
  if (streamUuid && currentYear && currentSemester && objectData) {
    url = '/entity/removeFromSemester/' + streamUuid + '/?currentYear=' + currentYear + '&currentSemester=' + currentSemester + '&sendChannelMessage=' + sendChannelMessage
  } else {
    return
  }
  if (entityType) {
    url += '&entityType=' + entityType
  }
  return HTTP().post(url, objectData)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
}

export const updateEntityInStream = (streamUuid, currentYear, currentSemester, objectData, entityType) => {
  let url = ''
  if (streamUuid && currentYear && currentSemester && objectData) {
    url = '/entity/updateEntityInStream/' + streamUuid + '/?currentYear=' + currentYear + '&currentSemester=' + currentSemester
  } else {
    return
  }
  if (entityType) {
    url += '&entityType=' + entityType
  }
  return HTTP().post(url, objectData)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
}

export const callGoogleCalendarLogin = () => {
  return HTTP().get('/entity/loginGoogleCalendar')
    .then(response => {
      let url = response.data
      return url
    })
    .catch(e => {
      console.log('Error:' + e)
    })
}

export const callGoogleCalendarSyncEndpoint = (streamUuid, currentYear, currentSemester, googleOAuthToken) => {
  let url = ''
  if (streamUuid && currentYear && currentSemester && googleOAuthToken) {
    url = '/entity/syncWithGoogleCalendar/' + streamUuid + '?currentYear=' + currentYear + '&currentSemester=' + currentSemester
  } else {
    return
  }
  let config = {
    headers: {
      'Content-Type': 'application/json'
    }
  }
  return HTTP().post(url, googleOAuthToken, config)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
}

export const getCoursePlanningStructure = (streamUuid) => {
  let url = ''
  if (streamUuid) {
    url = '/entity/coursePlanningStructure/' + streamUuid
  } else {
    return
  }
  return HTTP().get(url)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
}



// WEBPACK FOOTER //
// ./src/app/semester/api.js